import MinLiveVideo from './MinLiveVideo.vue'
export default MinLiveVideo



// WEBPACK FOOTER //
// ./src/views/monitoring/minLiveVideo/index.js